import { useState } from "react";

import ProfilePhotoUpload from "./components/ProfilePhotoUpload";
import PersonalForm from "./components/PersonalForm";
import OTPVerification from "./components/OTPVerification";

import "./OwnerDetailsStep.css";

function OwnerDetailsStep({

    providerData,

    setProviderData,

    nextStep,

    previousStep,

}) {

    const [isEmailVerified, setIsEmailVerified] = useState(false);

    const validate = () => {

    if (!providerData.photos?.profilePhoto) {
        alert("Profile photo is required.");
        return false;
    }

    if (!providerData.owner?.name?.trim()) {
        alert("Owner name is required.");
        return false;
    }

    if (!/^[6-9]\d{9}$/.test(providerData.owner?.phone || "")) {
        alert("Enter a valid mobile number.");
        return false;
    }

    if (!providerData.owner?.email) {
        alert("Email is required.");
        return false;
    }

    if (!isEmailVerified) {
        alert("Please verify your email.");
        return false;
    }

    if (!providerData.owner?.gender) {
        alert("Please select gender.");
        return false;
    }

    return true;
};

    const handleContinue = () => {

        if (!validate()) return;

        nextStep();

    };

    return (

        <div className="owner-step">

            <h1>

                Owner Information

            </h1>

            <p>

                Please provide your personal details.

            </p>

            <ProfilePhotoUpload

                providerData={providerData}

                setProviderData={setProviderData}

            />

            <PersonalForm

                providerData={providerData}

                setProviderData={setProviderData}

            />

          <OTPVerification
    email={providerData.owner?.email}
    ownerName={providerData.owner?.name}
    businessName={providerData.business?.businessName}
    isVerified={isEmailVerified}
    setIsVerified={setIsEmailVerified}
/>

            <div className="button-row">

                <button

                    className="back-btn"

                    onClick={previousStep}

                >

                    ← Back

                </button>

                <button

    className="next-btn"

    onClick={handleContinue}

    disabled={!isEmailVerified}

>

    Continue →

</button>

            </div>

        </div>

    );

}

export default OwnerDetailsStep;